"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeWindowProperty = void 0;
// istanbul ignore file @preserve --No need to test mocking helpers
const changeWindowProperty = (propertyKey, value) => {
  Object.defineProperty(window, propertyKey, {
    writable: true,
    configurable: true,
    value
  });
};
exports.changeWindowProperty = changeWindowProperty;
//# sourceMappingURL=changeWindowProperty.js.map